import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginatedFetchTable from '../PaginatedFetchTable';
import Icon from '../Icon';
import StatusPill from '../StatusPill';

export default class StaffListsList extends Component {
  static propTypes = {
    apiUrl: PropTypes.string,
    perPage: PropTypes.number.isRequired,
    emptyImg: PropTypes.string.isRequired,
    defaultSort: PropTypes.string,
    curriculumList: PropTypes.bool.isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      className: PropTypes.string,
      sort: PropTypes.shape({
        id: PropTypes.string.isRequired,
        direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
      }),
    })).isRequired,
  };

  static defaultProps = {
    defaultSort: null,
    apiUrl: '',
  }

  renderRow(item) {
    return (
      <tr key={item.id}>
        <td>
          <div className="u-font-semibold u-truncate">
            <a href={item.staff_url}>
              { item.title }
            </a>
          </div>
        </td>
        <td>{ item.list_items_count }</td>
        { !this.props.curriculumList
          && <td><StatusPill status={item.auto_rsvp_state} /></td> }
        <td>
          <StatusPill status={item.published_state} />
        </td>
        <td className="actions">
          <a href={item.edit_staff_url} className="Button">
            <Icon name="edit" className="u-mr-0" />
          </a>
        </td>
      </tr>
    );
  }

  render() {
    const {
      apiUrl, perPage, emptyImg, columns, defaultSort,
    } = this.props;
    return (
      <PaginatedFetchTable
        apiUrl={apiUrl}
        perPage={perPage}
        emptyImg={emptyImg}
        columns={columns}
        defaultSort={defaultSort}
        renderRow={this.renderRow.bind(this)}
      />
    );
  }
}
